import type { MainView } from '../types';

interface Props {
  view: MainView;
  counts: Record<MainView, number>;
  onChange: (view: MainView) => void;
}

const tabs: Array<{ value: MainView; label: string }> = [
  { value: 'todos', label: '待辦' },
  { value: 'reminders', label: '提醒' },
  { value: 'calendar', label: '行事曆' },
];

export function MainTabs({ view, counts, onChange }: Props) {
  return (
    <nav className="main-tabs" aria-label="主視圖">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={view === tab.value ? 'active' : ''}
          type="button"
          onClick={() => onChange(tab.value)}
          aria-current={view === tab.value ? 'page' : undefined}
        >
          {tab.label}
          <span>{counts[tab.value]}</span>
        </button>
      ))}
    </nav>
  );
}
